import { CategoryWifiProfileConfiguration } from '@era/settings-sdk';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export type CategoryWifiProfilePresetConfigurationState = EntityState<CategoryWifiProfileConfiguration>;

export function selectId(wifiProfile: CategoryWifiProfileConfiguration): string {
  return [wifiProfile.wifiProfileId, wifiProfile.categoryType, wifiProfile.categoryId].join('-');
}

export const adapter: EntityAdapter<CategoryWifiProfileConfiguration> =
  createEntityAdapter<CategoryWifiProfileConfiguration>({
    selectId,
  });

export const initialState: CategoryWifiProfilePresetConfigurationState = adapter.getInitialState();
